import { getEnvironment, isDevelopment, isLocal } from './environment';

// OneSchema webhook keys: https://foresightdata.oneschema.co/developer/webhooks
export function getListUploadWebhookKey() {
  if (isDevelopment() || isLocal()) {
    return 'nestdev';
  }
  if (getEnvironment() === 'demo') {
    return 'nestdemo';
  }
  return getEnvironment();
}
